import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import { SearchMeetings } from './search-meetings';
import { PublicMeetingsContainer } from './public-meetings-container';

const AntTabs = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: theme.ui.primary,
  },
}))(Tabs);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 24,
  },

  createMeeting: {
    marginRight: 16,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '30px 0',
  },
  tab: {
    marginBottom: 16,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export const PublicMeetingTab = () => {
  const classes = useStyles();
  const theme = useTheme();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AntTabs value={value} onChange={handleChange} className={classes.tab}>
        <SearchMeetings />
      </AntTabs>

      <TabPanel value={value} index={0} dir={theme.direction}>
        <PublicMeetingsContainer />
      </TabPanel>
    </div>
  );
};
